import React, { Component } from 'react';
import moment from 'moment';
import { FORMAT_NUMBER } from '../libs/utils/Const';
import config from '../config';
import ApiClient from '../libs/apiClient';
const apiClient = ApiClient.getInstance();
const today = moment(new Date()).format('YYYY-MM-DD');

const tapTitles = [
    "Clientes y tipo de documento base",
    "Documentos base",
    "Partidas individuales del documento base",
    "Consolidaciones",
    "Vista previa de resultados",
    "Informe de totales"
];

const headers0 = [
    { title: "#", class: 'sticky-header'},
    { title: "Código SN"},
    { title: "Nombre SN"}, 
    { title: " "},
];

const headers1 = [
    { title: "", class: 'sticky-column', styles: { width: 20 }},
    { title: "#", styles: { maxWidth: 40 }},
    { title: "#"},
    { title: "Fecha"}, 
    { title: "Cliente"},
    { title: "Fecha de Venc."}, 
    { title: "Comentarios"},
    { title: "Fecha de Cont."},
];

const headers2 = [
    { title: "#"},
    { title: "Proveedor"},
    { title: "Serie doc. obj.", styles: { width: 100 }},
    { title: "Doc. base"}, 
    { title: "N° Articulo"},
    { title: "Desc. Articulo"}, 
    { title: "Cantidad"},
    { title: "Precio/Unidad"}, 
    { title: "% de descuento"}, 
    { title: "Después del descuento"}, 
    { title: "Total (DOC)"}, 
    { title: "Almacen"}, 
    { title: "Fecha entrega"},
];
 
const tabValues3 = [
    {Value:'', Tittle: ''},
    {Value:'1', Tittle: 'Fecha de entrega'},
    {Value:'2', Tittle: 'Forma de envió'},
    {Value:'3', Tittle: 'Dirección de entrega'},
    {Value:'4', Tittle: 'Idioma'},
    {Value:'5', Tittle: 'Serie'},
    {Value:'6', Tittle: 'Fecha de contabilización'},
    {Value:'7', Tittle: 'Número de referencia de SN'},
    {Value:'8', Tittle: 'Moneda del documento'},
    {Value:'9', Tittle: 'Código de proyecto'},
];

const headers5 = [
    { title: "#", class: 'sticky-column', styles: { width: 30 }},
    { title: " ", styles: { width: 20 }},
    { title: "Mensaje"},
    { title: "Ayuda"},
    { title: "Contexto"}, 
    { title: "Fecha / Hora"},
];

const docValues = [
    {Value:'P', Tittle: 'Pedido', View: 'PurchaseOrder'},
    {Value:'Q', Tittle: 'Oferta de compra', View: 'PurchaseQuotation'},
    {Value:'R', Tittle: 'Solicitud de compra', View: 'PurchaseRequest'},
    {Value:'W', Tittle: 'Orden de fabricación', View: 'productionOrder'}
];

const date = (value) => {
    let dateObj = new Date(value);
    dateObj.setMinutes(dateObj.getMinutes() + dateObj.getTimezoneOffset());
    return moment(dateObj).format("DD-MM-YYYY");
};

class ContentProvConfAssistant extends Component {
    constructor(props) {
        super(props);
        this.state = {
            activeTab: 0,
            destDocValue: 'P',
            finalStep: false,
            BaseDocument: '17',
            partners: [],
            allOpenDocs: true,
            BaseDocuments: [],
            documentsLines: [],
            itemsSelectAll: true,
            series: [],
            targetDocSerie: '',
            sequenceLines: false,
            printDestDoc: false,
            applicant: 'U', 
            user: JSON.parse(localStorage.getItem(config.localStorageNamed + 'currentUser')),
            draft: false,
            sendMail: false,
            requiredDate: today,
            varDate: today,
            consolidation: 'W',
            whsStartfrom: false,
            startfrom1: false, 
            startfromSelect1: '',
            startfrom2: false, 
            startfromSelect2: '',
            ifAnError: '1',
            deliveryDoc: '1',
            resultsCreation: [],
            tab5Error: true,
            tab5Info: true,
            creationFlag:false,
            docVals: docValues,
        };
    }
    
    componentDidMount = () => {
        this.setClasses();
    }

    setClasses = () => {
        document.getElementById('nav-tab-0').classList.add('active');
        document.getElementById('tab-0').classList.add('active', 'show');
        for (let i = 0; i <= 5; i++) {
            const element = document.getElementById(`nav-tab-${i}`);
            if (element) element.classList.add('disabled');
        }    
    }

    truncateTitle = (title, length = 10) => {
        return title.length > length ? title.substring(0, length) + "..." : title;
    };

    onChangeInputs = async (e, index = null) => {
        let { name, value, type, checked } = e.target;
        let documentsLinesCopy = [...this.state.documentsLines];
        const { refreshModel, newOrderModel } = this.props; 
        value = type === 'checkbox' ? checked : value;
    
        switch (name) {
            case 'targetDocSerie':
                const updatedDocumentsLines = documentsLinesCopy.map((document) => ({ ...document, Serie: value }));
                this.setState({ documentsLines: updatedDocumentsLines, targetDocSerie: value});
                break;
            case 'itemsSelectAll':
                documentsLinesCopy = documentsLinesCopy.map(line => ({ ...line, checked: value }))
                this.setState({ itemsSelectAll: value, documentsLines: documentsLinesCopy });
                break;
            case 'ItemSelect':
                documentsLinesCopy[index].checked = value;
                const itemsSelectAll = documentsLinesCopy.every(line => line.checked === true);
                this.setState({ documentsLines: documentsLinesCopy, itemsSelectAll });
                break;
            case 'ItemSerie':
                documentsLinesCopy[index].Serie = value;
                this.setState({ documentsLines: documentsLinesCopy });
                break;
            case 'SupplierItem':
                documentsLinesCopy[index].CardCode = value;
                this.setState({ documentsLines: documentsLinesCopy });
                break;
            case 'supplier':
                newOrderModel.SupplierCode = value;
                refreshModel(newOrderModel);
                break;
            case 'destDocValue':
                const consolidation = value === 'Q' ? 'B' : 'W';
                await this.setState({ destDocValue: value, consolidation });
                await this.getSeries();
                break;
            default:
                this.setState({ [name]: value });
                break;
        }
    };

    renderBody = () => {
        return (
            <div className="tab-content" style={{ paddingTop: 5, textAlign: 'left' }}>
                {tapTitles.map((_, index) => (
                    <div
                        key={index}
                        className={`w-100 tab-pane fade`}
                        id={`tab-${index}`}
                        role="tabpanel"
                        aria-labelledby={`nav-tab-${index}`}
                        style={{ maxHeight: 2000, paddingTop: 5 }}
                    >
                        {this.renderTabContent(index)}
                    </div>
                ))}
            </div>
        );
    };

    renderTabContent = (index) => {
        let content = '';
        switch (index) {
            case 0:
                content = this.renderTabContent0();
                break;
            case 1:
                content = this.renderTabContent1();
                break;
            case 2:
                content = this.renderTabContent2();
                break;
            case 3:
                content = this.renderTabContent3();
                break;
            case 4:
                content = this.renderTabContent4();
                break;
            case 5:
                content = this.renderTabContent5();
                break;
            default:
                content = null;
                break;
        }
        return content;
    }

    renderTabContent0 = () => {
        const { openSelectionCriteriaModal } = this.props;
        const { partners, allOpenDocs, BaseDocument } = this.state;
        return (
            <>
                <div className="row pr-0">   
                    <div className="col-sm-4">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Doc. base</span>
                            </div>
                            <select 
                                type="text" 
                                className="form-control"
                                onChange={(e) => this.setState({BaseDocument: e.target.value, partners: []})} 
                                value={BaseDocument}>
                                <option value='17'>Orden de venta</option>
                                <option value='23'>Oferta de venta</option>
                            </select>
                        </div>
                    </div>
                </div> 
                <div className="table-scroll mb-4" style={{ maxHeight: 600 }}>
                    <table
                        id="dataTable-0"
                        className="display table-hover"
                        style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                        <thead className="table-header-yellow">
                            <tr style={{ textAlign: "center"}}>
                                {headers0.map((header, index) => {
                                    return (
                                        <td key={index} className={`${header.class ?? ''} sticky-header`} style={{ background: "#d2ab24" }}>{header.title}</td>    
                                    );
                                })}                     
                            </tr>
                        </thead>
                        <tbody>
                            {partners.map((record, index) => {
                                const { CardCode, CardName, checked} = record;
                                return (
                                    <tr key={index} style={{ textAlign: "center"}}>
                                        <td>{index + 1}</td>   
                                        <td>{CardCode}</td>   
                                        <td className='text-left'>{CardName}</td>   
                                        <td>
                                            <div className='form-check'>
                                                <input
                                                    type="checkbox"
                                                    onChange={(e) => this.selectPartner(index, e.target.checked)}
                                                    checked={checked}
                                                />
                                            </div>
                                        </td>   
                                    </tr> 
                                );
                            })}                     
                        </tbody>
                    </table>
                </div>
                <div className="row pr-0">   
                    <div className="col-sm-12 d-flex justify-content-end align-items-center mb-3">
                        <button 
                            type="button" 
                            className="btn btn-secondary mr-2"
                            disabled={partners.length === 0}
                            onClick={() => this.setState({partners: []})}
                        >
                            Borrar entradas de tabla
                        </button>
                        <button 
                            type="button" 
                            className="btn btn-secondary"
                            onClick={()=> openSelectionCriteriaModal()}
                        >
                            Agregar
                        </button>
                    </div>
                    <div className="col-sm-5">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        onChange={(e) => this.setState({allOpenDocs: e.target.checked})} 
                                        checked={allOpenDocs}/>
                                </span>
                            </div>
                            <label className="form-control" style={{overflow: 'hidden'}} >Incluir todos los documentos base abiertos</label>
                        </div>
                    </div>
                </div>
                {this.renderMotionBtn(0)}
            </>           
        );
    }

    renderTabContent1 = () => {
        const { finalStep, BaseDocuments, sequenceLines } = this.state;
        
        return (
            <>
                <div className="table-scroll mb-4" style={{ maxHeight: 600 }}>
                    <table
                        id="dataTable-1"
                        className="display table-hover"
                        style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                        <thead className="table-header-yellow">
                            <tr style={{ textAlign: "center"}}> 
                                {headers1.map((header, index) => {
                                    const styles = { background: '#d2ab24', ...header.styles ?? '' };
                                    return (
                                        <td key={index} className={`${header.class ?? ''} sticky-header`} style={styles}>{header.title}</td>    
                                    );
                                })}                     
                            </tr>
                        </thead>
                        <tbody>
                        {BaseDocuments.map((record, index) => {
                            const { DocNum, TaxDate, CardName, DocDueDate, Comments, DocDate, checked } = record;
                            return (
                                <tr key={index} style={{ textAlign: "center" }}> 
                                    <td className="sticky-column align-middle small" style={{ background: '#fff', width: 20 }}>
                                        <div className='form-check pl-0'>
                                            <input
                                                type="checkbox"
                                                onChange={(e) => this.selectDocument(index, e.target.checked)}
                                                checked={checked}
                                            />
                                        </div>
                                    </td>   
                                    <td className="align-middle" style={{ maxWidth: 40 }}>{index + 1}</td> 
                                    <td className="align-middle">{DocNum}</td> 
                                    <td className="align-middle">{date(TaxDate)}</td>       
                                    <td className="align-middle">{CardName}</td>       
                                    <td className="align-middle">{date(DocDueDate)}</td>       
                                    <td className="align-middle text-left text-wrap">{Comments}</td>       
                                    <td className="align-middle">{date(DocDate)}</td>       
                                </tr> 
                            );
                        })}     
                        </tbody>
                    </table>
                </div>
                <div className="row">
                    <div className="col-sm-4">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        name="finalStep"
                                        onChange={this.onChangeInputs}  
                                        checked={finalStep}/>
                                </span>
                            </div>
                            <label className="form-control" >Ir a paso final</label>
                        </div>
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        name="sequenceLines"
                                        onChange={this.onChangeInputs}  
                                        checked={sequenceLines}/>
                                </span>
                            </div>
                            <label className="form-control" style={{overflow: 'hidden'}}>Mantener secuencia original de lineas</label>
                        </div>
                    </div>
                </div>
                {this.renderMotionBtn(1)}
            </>          
        );
    }

    renderTabContent2 = (tab = false) => {
        const { openPartner, newOrderModel } = this.props;
        const { destDocValue, documentsLines, series, targetDocSerie, BaseDocument, printDestDoc, applicant, user, draft } = this.state;
        const { sendMail, requiredDate, varDate, itemsSelectAll } = this.state;
        const { SupplierCode, Supplier = {} } = newOrderModel;
        const textDate = (destDocValue === 'Q' || destDocValue === 'R') ? 'Valido hasta' : 'Fecha de entrega';
        const docsToCheck = ['P', 'Q', 'R'];
        const disabledStyle = tab ? { pointerEvents: 'none', opacity: 0.7 } : {};
        return (
            <>
                <div className="row pr-0" style={disabledStyle}>   
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Documento de destino</span>
                            </div>
                            <select 
                                type="text" 
                                className="form-control"
                                name='destDocValue' 
                                value={destDocValue}
                                onChange={this.onChangeInputs}>
                                {docValues.map((type, index) => {
                                    if (BaseDocument === '23' && index === 3) return null; 
                                    return (<option key={index} value={type.Value}>{type.Tittle}</option>)   
                                })}
                            </select>
                        </div>
                    </div>
                    {/* <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        name='printDestDoc' 
                                        onChange={this.onChangeInputs}
                                        checked={printDestDoc}/>
                                </span>
                            </div>
                            <label className="form-control" >Imprimir documento de destino</label>
                        </div>
                    </div> */}
                    <div className="col-sm-6">
                        {destDocValue !== 'W' && 
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text form-check">
                                        <input
                                            type="checkbox"
                                            name="draft"
                                            onChange={this.onChangeInputs}
                                            checked={draft}
                                        />
                                    </span>
                                </div>
                                <label className="form-control">Crear documento preliminar</label>
                         </div>
                        }
                    </div>
                    {docsToCheck.includes(destDocValue) &&
                        <>
                            {destDocValue !=='R' ? 
                                <div className="col-sm-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Proveedor</span>
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            name="supplier"
                                            value={SupplierCode}
                                            disabled={destDocValue === 'Q'}
                                            onChange={this.onChangeInputs}
                                            onKeyPress={(ev) => { if (ev.key === 'Enter') { openPartner(null, 'Supplier'); } }}
                                        />
                                        {(!tab && destDocValue !== 'Q') &&
                                            <button type="button" 
                                               style={{ backgroundColor: 'transparent', color: '#EABF28' }} 
                                               className="input-group-text" 
                                               onClick={() => openPartner(null, 'Supplier')}>
                                               <i className="fa fa-user fa-lg" aria-hidden="true" />
                                            </button> 
                                        }
                                    </div>
                                </div>
                            :
                                <div className="col-sm-6">
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Solicitante</span>
                                        </div>
                                        <select 
                                            type="text" 
                                            className="form-control"
                                            name='applicant' 
                                            disabled={true} 
                                            onChange={this.onChangeInputs}
                                            value={applicant}>
                                            <option value='U'>Usuario</option>
                                            <option value='E'>Empleado</option>
                                        </select>
                                        <div className="input-group-prepend">
                                        </div>
                                        <input
                                            type="text"
                                            className="form-control"
                                            value={user?.USER_CODE}
                                            disabled={true}
                                        />
                                    </div>
                                </div>
                            }
                            <div className="col-sm-6">
                                {/* <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text form-check">
                                            <input
                                                type="checkbox"
                                                name="draft"
                                                onChange={this.onChangeInputs}
                                                checked={draft}
                                            />
                                        </span>
                                    </div>
                                    <label className="form-control">Crear documento preliminar</label>
                                </div> */}
                            </div>
                            <div className="col-sm-6">
                                <div className="input-group mb-3">
                                    <div className="input-group-prepend">
                                        <span className="input-group-text font-weight-bold" id="basic-addon1">Nombre</span>
                                    </div>
                                    <input
                                        type="text"
                                        className="form-control"
                                        value={destDocValue === 'R' ? user?.U_NAME : (Supplier?.CardName || '')}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            {destDocValue === 'R' && 
                                <>
                                    <div className="col-sm-6">
                                        {/* <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text form-check">
                                                    <input
                                                        type="checkbox"
                                                        name="sendMail"
                                                        onChange={this.onChangeInputs}
                                                        checked={sendMail}
                                                    />
                                                </span>
                                            </div>
                                            <label 
                                                className="form-control" 
                                                title="Enviar correo electrónico si se agrego pedido o pedido de entrada de mercancia"
                                                style={{overflow: 'hidden'}} 
                                            > 
                                                Enviar correo electrónico si se agrego pedido o pedido de...
                                            </label>
                                        </div> */}
                                    </div>
                                    <div className="col-sm-6">
                                    </div>
                                    <div className="col-sm-6">
                                        {/* <div className="input-group mb-3">
                                            <div className="input-group-prepend">
                                                <span className="input-group-text font-weight-bold" id="basic-addon1">Dirección de correo</span>
                                            </div>
                                            <input
                                                type="email"
                                                className="form-control"
                                                name="mail"
                                                disabled={true}
                                                onChange={this.onChangeInputs}
                                                value={user?.E_Mail}
                                            />
                                        </div> */}
                                    </div>
                                    <div className="col-sm-6">
                                    </div>
                                </>
                            }
                            <div className="col-sm-6">
                                {(destDocValue === 'Q' || destDocValue === 'R') &&
                                    <div className="input-group mb-3">
                                        <div className="input-group-prepend">
                                            <span className="input-group-text font-weight-bold" id="basic-addon1">Fecha Necesaria</span>
                                        </div>
                                        <input
                                            type="date"
                                            className="form-control"
                                            name="requiredDate"
                                            value={requiredDate}
                                            onChange={this.onChangeInputs}
                                        />
                                    </div>
                                }
                            </div>
                        </>
                    }
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">Series de documento objetivo</span>
                            </div>
                            <select 
                                type="text" 
                                className="form-control"
                                name='targetDocSerie'
                                value={targetDocSerie} 
                                onChange={this.onChangeInputs}>
                                {series.map((serie, index) => {
                                    return (<option key={index} value={serie.Series}>{serie.SeriesName}</option>);   
                                })}
                            </select>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold" id="basic-addon1">{textDate}</span>
                            </div>
                            <input
                                type="date"
                                className="form-control"
                                name='varDate'
                                onChange={this.onChangeInputs} 
                                value={varDate} 
                            />
                        </div>
                    </div>
                </div> 
                <div className="table-scroll mb-4" style={{ maxHeight: 600 }}>
                    <table
                        id="dataTable-2"
                        className="display table-hover"
                        style={{ width: '100%', marginBottom: 40, marginRight: -30000, ...disabledStyle }}>
                        <thead className="table-header-yellow">
                            <tr style={{ textAlign: "center"}}> 
                                <td className="sticky-column sticky-header align-middle small" style={{ background: '#d2ab24', width: 20 }}>
                                    <div className='form-check pl-0'>
                                        <input
                                            type="checkbox"
                                            name="itemsSelectAll"
                                            onChange={this.onChangeInputs}
                                            disabled={tab}
                                            checked={itemsSelectAll}
                                        />
                                    </div>
                                </td>   
                                {headers2.map((header, index) => {
                                    const styles = { background: '#d2ab24', ...header.styles ?? '' };
                                    if (destDocValue === 'W' && index === 1) return null; 
                                    return (
                                        <td key={index} className={`${header.class ?? ''} sticky-header`} style={styles}>{header.title}</td>    
                                    );
                                })}                     
                            </tr>
                        </thead>
                        <tbody>
                            {documentsLines.filter(doc => (!tab || doc.checked) && (destDocValue !== 'W' || doc.TreeType === 'P')).map((doc, index) => {
                                const { CardCode, Serie, DocNum, ItemCode, Dscription, Quantity, Price, DiscPrcnt, LineTotal, WhsCode, DocDueDate, Currency, checked, id } = doc;
                                return (
                                    <tr key={index} style={{ textAlign: "center" }}> 
                                        <td className="sticky-column align-middle small" style={{ background: '#fff', width: 20 }}>
                                            <div className='form-check pl-0'>
                                                <input
                                                    type="checkbox"
                                                    name="ItemSelect"
                                                    onChange={(e) => this.onChangeInputs(e, id)}
                                                    checked={checked}
                                                />
                                            </div>
                                        </td>   
                                        <td className="align-middle">{index + 1}</td>    
                                        {destDocValue !== 'W' && 
                                            <td className="align-middle">
                                                <div className="input-group" style={{ width: 130 }}>
                                                    <input 
                                                        type="text" 
                                                        className="form-control"
                                                        name="SupplierItem"
                                                        onChange={(e) => this.onChangeInputs(e, index)}
                                                        onKeyPress={(ev) => { if (ev.key === 'Enter') { openPartner(index, 'SupplierItem'); } }}
                                                        value={CardCode || ''} 
                                                    />
                                                    {!tab &&
                                                        <button 
                                                            type="button" 
                                                            style={{ backgroundColor: 'transparent', color: '#EABF28' }} 
                                                            className="input-group-text" 
                                                            onClick={() => openPartner(index, 'SupplierItem')}>
                                                            <i className="fa fa-user fa-lg" aria-hidden="true" />
                                                        </button>
                                                    }
                                                </div>
                                            </td>  
                                        }  
                                        <td className="align-middle" style={{ width: 100 }}>
                                            <select 
                                                type="text" 
                                                className="form-control"
                                                name="ItemSerie"
                                                onChange={(e) => this.onChangeInputs(e, id)} 
                                                value={Serie}>
                                                {series.map((serie, index) => {
                                                    return (<option key={index} value={serie.Series}>{serie.SeriesName}</option>)   
                                                })}
                                            </select>
                                        </td>
                                        <td className="align-middle">{DocNum}</td>
                                        <td className="align-middle">{ItemCode}</td>
                                        <td className="align-middle text-left">{Dscription}</td>
                                        <td className="align-middle">{FORMAT_NUMBER.new(Quantity)}</td>
                                        <td className="align-middle">{`${Currency} ${FORMAT_NUMBER.new(Price)}`}</td>
                                        <td className="align-middle">{FORMAT_NUMBER.new(DiscPrcnt)}</td>
                                        <td className="align-middle">{`${Currency} ${FORMAT_NUMBER.new(Number(Price) - (Number(Price) * (Number(DiscPrcnt) / 100)))}`}</td>
                                        <td className="align-middle">{`${Currency} ${FORMAT_NUMBER.new(LineTotal)}`}</td>
                                        <td className="align-middle">{WhsCode}</td>
                                        <td className="align-middle">{date(DocDueDate)}</td>         
                                    </tr> 
                                );
                            })}     
                        </tbody>
                    </table>
                </div>
                {this.renderMotionBtn(tab ? 4 : 2)}
            </>           
        );
    }

    renderTabContent3 = () => {
        const { destDocValue, consolidation, whsStartfrom, startfrom1, startfromSelect1, startfrom2, startfromSelect2, ifAnError, deliveryDoc } = this.state;
        let subject = '';

        switch(destDocValue){
            case 'R': subject = 'solicitante'
            break;
            case 'W': subject = 'articulo'
            break;
            default: subject = 'proveedor' 
            break;
        }

        return (
           <>
                <h5 className="mt-3">Opciones de consolidación</h5>
                <div className="row pr-0 mt-3">
                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        type="radio"
                                        name='consolidation'
                                        value='W'
                                        disabled={destDocValue === 'Q'}
                                        onChange={this.onChangeInputs}
                                        checked={consolidation === 'W'}/>
                                </span>
                            </div>
                            <label className="form-control">Sin consolidación</label>
                        </div>
                    </div>
                    <div className="col-12 col-lg-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-radio">
                                    <input
                                        type="radio"
                                        name='consolidation'
                                        value='B'
                                        // disabled={destDocValue === 'Q'}
                                        disabled={true}
                                        onChange={this.onChangeInputs}
                                        checked={consolidation === 'B'}/>
                                </span>
                            </div>
                            <label className="form-control">Consolidado por:</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                         type="checkbox"
                                         disabled={true} 
                                         defaultChecked={true}/>
                                </span>
                            </div>
                            <label className="form-control">Proveedor (estándar del sistema)</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        disabled={true} 
                                        defaultChecked={true}/>
                                </span>
                            </div>
                            <label className="form-control">Proveedor (estándar del sistema)</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        disabled={true} 
                                        defaultChecked={true}/>
                                </span>
                            </div>
                            <label className="form-control">Series de documento objetivo (estándar de sistema)</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        disabled={true} 
                                        defaultChecked={true}/>
                                </span>
                            </div>
                            <label className="form-control">Series de documento objetivo (estándar de sistema)</label>
                        </div>
                    </div>
                    <div className="col-sm-6">
                    </div>    
                    <div className="col-sm-6">
                        {destDocValue !== 'W' &&
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text form-check">
                                        <input
                                            type="checkbox"
                                            name="whsStartfrom"
                                            disabled={consolidation === 'W' || destDocValue === 'Q'}
                                            onChange={this.onChangeInputs}
                                            checked={whsStartfrom}/>
                                    </span>
                                </div>
                                <label className="form-control">Almacén (partir por)</label>
                            </div>
                        }
                    </div>
                    <div className="col-sm-6">
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        name="startfrom1"
                                        disabled={consolidation === 'W' || destDocValue === 'Q'}
                                        onChange={this.onChangeInputs}
                                        checked={startfrom1}/>
                                </span>
                                <select 
                                    type="text" 
                                    className="form-control"
                                    name="startfromSelect1"
                                    disabled={consolidation === 'W' || destDocValue === 'Q'}
                                    onChange={this.onChangeInputs}
                                    value={startfromSelect1}>
                                    {tabValues3.map((type, index) => {
                                        return (<option key={index} value={type.Value}>{type.Tittle}</option>)   
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        {/* {destDocValue === 'Q' && 
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text font-weight-bold">
                                        Entrega de documento
                                    </span>
                                    <select 
                                        type="text" 
                                        className="form-control"
                                        style={{width: 240}}
                                        name='deliveryDoc'
                                        value={deliveryDoc}
                                        onChange={this.onChangeInputs}>
                                        <option value='1'>None</option> 
                                        <option value='2'>Create Online Document</option>     
                                    </select>
                                </div>
                            </div>
                        } */}
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text form-check">
                                    <input
                                        type="checkbox"
                                        name="startfrom2"
                                        disabled={consolidation === 'W' || destDocValue === 'Q'}
                                        onChange={this.onChangeInputs}
                                        checked={startfrom2}/>
                                </span>
                                <select 
                                     type="text" 
                                     className="form-control"
                                     name="startfromSelect2"
                                     disabled={consolidation === 'W' || destDocValue === 'Q'}
                                     onChange={this.onChangeInputs}
                                     value={startfromSelect2}>
                                    {tabValues3.map((type, index) => {
                                        return (<option key={index} value={type.Value}>{type.Tittle}</option>)   
                                    })}
                                </select>
                            </div>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="input-group mb-3">
                            <div className="input-group-prepend">
                                <span className="input-group-text font-weight-bold">
                                    Si se produce un error
                                </span>
                                <select 
                                    type="text" 
                                    className="form-control"
                                    name='ifAnError'
                                    onChange={this.onChangeInputs}
                                    value={ifAnError}>
                                    <option value='1'>{`Pasar al siguiente ${subject}`}</option> 
                                    <option value='2'>Detener la ejecución</option>     
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                {this.renderMotionBtn(3)}
           </>
        );
    }

    renderTabContent4 = () => {
        // En esta pestaña se renderiza lo elegido en la 2
        // Pero con los resultados que se van a obtener
        return(this.renderTabContent2(true));
    }

    renderTabContent5 = () => {
        const { tab5Info, tab5Error, resultsCreation,  } = this.state;
        return(
            <>
                <div className='row'>
                    <div className="col-12 col-md-6">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text form-check">
                                        <input
                                            type="checkbox"
                                            name="tab5Error"
                                            onChange={this.onChangeInputs}
                                            checked={tab5Error}/>
                                    </span>
                                </div>
                                <label className="form-control">Errores</label>
                            </div>
                        </div>
                        <div className="col-12 col-md-6">
                            <div className="input-group mb-3">
                                <div className="input-group-prepend">
                                    <span className="input-group-text form-check">
                                        <input
                                            type="checkbox"
                                            name="tab5Info"
                                            onChange={this.onChangeInputs}
                                            checked={tab5Info}/>
                                    </span>
                                </div>
                                <label className="form-control">Información</label>
                            </div>
                        </div>
                    </div>
                    <div className="table-scroll mb-4" style={{ maxHeight: 600 }}>
                    <table
                        id="dataTable-0"
                        className="display table-hover"
                        style={{ width: '100%', marginBottom: 40, marginRight: -30000 }}>
                        <thead className="table-header-yellow">
                            <tr style={{ textAlign: "center"}}>
                                {headers5.map((header, index) => {
                                    const styles = { background: '#d2ab24', ...header.styles ?? '' };
                                    return (
                                        <td key={index} className={`${header.class ?? ''} sticky-header`} style={styles}>{header.title}</td>    
                                    );
                                })}
                            </tr>
                        </thead>
                        <tbody>
                            {resultsCreation.filter(result => {
                                if (tab5Info && tab5Error) {
                                    return true; 
                                } else if (tab5Info) {
                                    return !result.error;
                                } else if (tab5Error) {
                                    return result.error;
                                }
                                return false; 
                            }).map((result, index) => {
                                const { icon, message, date, context, error} = result;
                                const textColor = error ? 'text-danger' : 'text-dark';
                                const iconColor = error ? 'text-danger' : 'text-primary';
                                return (
                                    <tr key={index} style={{ textAlign: "center"}}>
                                        <td className="sticky-column align-middle" style={{ width: 30, background: "#fff" }}>{index + 1}</td> 
                                        <td className="align-middle" style={{ width: 20 }}>                                            
                                            <i className={`fa ${icon} ${iconColor}`} aria-hidden="true"/>
                                        </td> 
                                        <td className={`align-middle text-left text-wrap ${textColor}`}>{message}</td>   
                                        <td className="align-middle"></td>   
                                        <td className="align-middle text-left text-wrap">{context}</td>   
                                        <td className="align-middle">{date}</td>
                                    </tr>
                                );
                            })} 
                        </tbody>
                    </table>
                </div>
            </>
        );
    }

    renderMotionBtn = (index) => {
        return (
            <div className='row'>
                <div className="col-sm-12 d-flex justify-content-end align-items-center mb-3">
                    {index !== 0 && (
                        <button 
                            type="button" 
                            className="btn btn-secondary mr-2"
                            onClick={() => this.motion(index, false)}
                        >
                            Atrás
                        </button>
                    )}
                    {(index !== 5 && this.validateTabs(index)) &&(
                        <button 
                            type="button" 
                            className="btn btn-secondary"
                            onClick={()=> this.motion(index, true)}
                            >
                            Siguiente
                        </button>
                    )}
                </div>
            </div>
        );
    };

    motion = async (index, next) => {
        const prevIndex = index;

        if(index === 1 && this.state.finalStep) index = 3;

        index = next ? index + 1 : index - 1;

        if (next && !(await this.valuesForTabs(index))) return;

        this.setState({ activeTab: index });        

        const navTab = document.getElementById(`nav-tab-${index}`);
        const prevNavTab = document.getElementById(`nav-tab-${prevIndex}`);
        const tabContent = document.getElementById(`tab-${index}`);
        const prevTabContent = document.getElementById(`tab-${prevIndex}`);

        if (navTab) {
            // if (navTab.classList.contains('disabled')) navTab.classList.remove('disabled');
            navTab.classList.add('active');
        }

        if (tabContent) tabContent.classList.add('active', 'show');

        if (prevNavTab) prevNavTab.classList.remove('active');

        if (prevTabContent) prevTabContent.classList.remove('active', 'show');
    };

    validateTabs = (tab) => {
        const { partners, BaseDocuments, documentsLines, destDocValue} = this.state;
        let flag = false;

        switch(tab){
            case 0:
                if (partners.filter(partner => partner.checked).length > 0) flag = true;
            break;
            case 1:
                if (BaseDocuments.filter(doc => doc.checked).length > 0) flag = true;
            break;
            case 2:  
                const auxLines = documentsLines.filter(line => line.checked && (destDocValue !== 'W' || line.TreeType === 'P'));
                flag = auxLines.length > 0 && 
                auxLines.every(line => 
                    (destDocValue !== 'W' && line.CardCode) || 
                    (destDocValue === 'W' && line.Serie)
                );          
            break;
            default:
                flag = true;
            break;
        }

        return flag;
    }

    selectPartner = (index, checked) => {
        const partnersCopy = [...this.state.partners];
      
        partnersCopy[index] = { ...partnersCopy[index], checked };
        
        this.setState({ partners: partnersCopy });
    }

    selectDocument = (index, checked) => {
        const BaseDocumentsCopy = [...this.state.BaseDocuments];
      
        BaseDocumentsCopy[index] = { ...BaseDocumentsCopy[index], checked };
        
        this.setState({ BaseDocuments: BaseDocumentsCopy });
    }

    valuesForTabs = async (tab) => {
        const { showAlert } = this.props;
        let flag = false;
        let message = '';
        let validate = {};
        switch(tab){
            case 1: {
                if(!this.state.allOpenDocs) {
                    message = 'No hay documentos disponibles, incluya todos los documentos base abiertos';
                    break;
                } 

                const documents = await this.getBaseDocuments();
                message = documents?.message || '';
                if (documents.status === 1) {
                    if (documents.data.length > 0) {  
                        const selectDocuments = documents.data.map(document => ({ ...document, checked: false }));
                        this.setState({BaseDocuments: selectDocuments});
                        flag = true;
                    } else {
                        message = 'No hay documentos disponibles';
                    }
                }
            }
            break;
            case 2:
            case 4:
                validate = await this.validateFinalStep(tab);
                flag = validate.flag;
                message = validate.message;
            break;
            case 5:
                validate = await this.groupLines(); 
                flag = validate.flag;
                message = validate.message;    
                if (flag) await this.createDocuments(validate.finalItems);
            break;
            default:
                flag = true;
            break;
        }

        if(!flag) showAlert({ type: 'error', message, timeOut: 5000});

        return flag;
    }

    getBaseDocuments = async () => {
        const { enableSpinner } = this.props;
        const { partners, BaseDocument } = this.state;
        
        const data = {
            action: 2,
            params: {
                ObjType: BaseDocument || '',
                partners: partners.filter(partner => partner.checked),
            }
        };

        enableSpinner(true);
        const documents = await apiClient.recordsForAssistant(data);
        enableSpinner(false);

        return documents;
    }

    getDocumentLines = async () => {
        const { enableSpinner } = this.props;
        const { BaseDocuments, BaseDocument } = this.state;
        const documents = BaseDocuments.filter(doc => doc.checked === true);
        const documentsLines = [];

        for (let i = 0; i < documents.length; i++) {   
            const data = {
                action: 3,
                params: {
                    ObjType: BaseDocument || '',
                    DocEntry: documents[i].DocEntry,
                }
            };  

            enableSpinner(true);
            const lines = await apiClient.recordsForAssistant(data);
            documentsLines.push(...lines.data);
            enableSpinner(false);
        }

        const destDoc = (documentsLines.every(doc => doc.TreeType === 'P')) && BaseDocument === '17' ? 'W' : 'P';
        this.setState({destDocValue: destDoc});

        return documentsLines.map((line, index) => ({...line, checked: true, id: index}));
    }

    getSeries = async () => {
        const { enableSpinner, selectTable, showAlert } = this.props;
        const { destDocValue, documentsLines } = this.state;
        const view = docValues.find(doc => doc.Value === destDocValue)?.View;
        const table = selectTable(view);

        const dataSerie = {
            docType: table.docType,
            docSubType: table.docSubType
        };

        enableSpinner(true);
        const seriesResponse = await apiClient.getSeries(dataSerie);
        enableSpinner(false);

        if (!seriesResponse.status) return showAlert({ type: 'error', message: seriesResponse.message});
        const series = seriesResponse.data.filter(serie => serie.ObjectCode === table.docType);
      
        if (series.length > 0) {
            const DfltSeries = series[0]?.DfltSeries;
            const updatedDocumentsLines = documentsLines.map((document) => ({ ...document, Serie: DfltSeries }));

            this.setState({series, targetDocSerie: DfltSeries, documentsLines: updatedDocumentsLines });
        }else{
            showAlert({ type: 'error', message: 'No hay series disponibles'});
        }
    }

    validateFinalStep = async (tab) => {
        const { finalStep } = this.state;
        let flag = false;
        let message = '';

        if (tab === 2 || (finalStep && tab === 4)) {
            const documentsLines = await this.getDocumentLines();
            
            if (documentsLines.length === 0) {
                message = 'No hay partidas disponibles por el momento';
                return { flag, message };
            }

            await this.setState({ documentsLines }); 
            if (finalStep && tab === 4 && !documentsLines.every(line => line.CardCode)) {
                message = 'Agrega el proveedor faltante en la pestaña 2';
                this.setState({ finalStep: false }); 
                return { flag, message };
            }
            
            flag = true;   
            await this.getSeries();
        } else {
            flag = true;
        }
    
        return { flag, message };
    }
    
    createDocuments = async (docs) => {
        const { enableSpinner, selectTable } = this.props;
        const { destDocValue, draft, series, user, ifAnError, varDate, BaseDocument, requiredDate, creationFlag } = this.state;
        const table = selectTable(docValues.find(doc => doc.Value === destDocValue)?.View);
        let icon = '', text = '', context = '', error = false, resultsCreation = [];

        resultsCreation.push({
            icon: 'fa-info-circle',
            message: 'Se inició la creación de la confirmación de aprovisionamiento',
            date:`${today} ${moment().format('HH:mm:ss')}`,
            error 
        });

        for (let i = 0; i < docs.length; i++) {
            const lines = docs[i];
            const doc = {
                destino: table.name,
                model: { 
                    draft, 
                    varDate,
                    requiredDate,
                    originDoc: BaseDocument,
                    lines, 
                    docType: table.docType, 
                    origin: 'assistant',
                    userCode: user?.USER_CODE,
                    userID: user?.USERID
                }                
            };

            enableSpinner(true);
            const { status, data, message } = await apiClient.createNewDocProd(doc);
            enableSpinner(false);

            const { Serie, CardCode, ItemCode } = lines[0];
            const cCode = destDocValue === 'R' ? user?.USER_CODE : (destDocValue === 'W' ? ItemCode : CardCode);
            const nameSerie = series.find(serie => String(serie.Series) === Serie)?.SeriesName;
            const descDoc = `creó el número de documento de ${destDocValue === 'W' ? 'fabricación' : 'aprovisionamiento'}`;

            if (status === 1 && data?.DocNum) {
                if (!creationFlag) this.setState({creationFlag: true});

                icon = 'fa-info-circle';
                text = `Se ${descDoc} ${data.DocNum} para ${cCode}, con serie: ${nameSerie}`;
                error = false;
            }else{
                icon = 'fa-times-circle';
                text = `No se ${descDoc} para ${cCode}, con serie: ${nameSerie}`;
                context = data?.sapError ? `Error SAP: ${message}` : message;
                error = true;
            }

            if (draft) {
                const suffix = descDoc.split('de ')[1]; 
                text = text.replace(`de ${suffix}`, `preliminar de ${suffix}`);
            }

            const date = `${today} ${moment().format('HH:mm:ss')}`;
            resultsCreation.push({icon, message: text, date, context, error});

            if (status === 0 && ifAnError === '2') break;
        }

        resultsCreation.push({
            icon: resultsCreation[0].icon,
            message: resultsCreation[0].message.replace('Se inició', 'Finalizó'),
            date: `${today} ${moment().format('HH:mm:ss')}`,
            error: false
        });

        this.setState({resultsCreation});
    }

    groupLines = () => {
        const { destDocValue, documentsLines } = this.state;
        let finalItems = [];

        // Filtramos las lineas finales según sea el caso
        const auxItems = documentsLines.filter(line => line.checked && 
            (destDocValue !== 'W' || line.TreeType === 'P')).map(line => ({
                ...line, 
                Serie: String(line.Serie), 
                DocEntry: Number(line.DocEntry) 
            })
        );

        // Las lineas se deben de agrupar de forma distinta según sea el caso
        // Cada agrupación sera un documento creado
        const finalGrouping = auxItems.reduce((acc, line) => {
            const { DocEntry, ItemCode, Serie, CardCode } = line;

            switch(destDocValue){
                case 'W':
                    acc[DocEntry] = acc[DocEntry] || {};
                    acc[DocEntry][ItemCode] = acc[DocEntry][ItemCode] || {};
                    acc[DocEntry][ItemCode][Serie] = acc[DocEntry][ItemCode][Serie] || [];
                    acc[DocEntry][ItemCode][Serie].push(line);
                break; 
                case 'R':
                    acc[DocEntry] = acc[DocEntry] || {};
                    acc[DocEntry][Serie] = acc[DocEntry][Serie] || [];
                    acc[DocEntry][Serie].push(line);
                break; 
                default:
                    acc[CardCode] = acc[CardCode] || {};
                    acc[CardCode][Serie] = acc[CardCode][Serie] || [];
                    acc[CardCode][Serie].push(line);
                break; 
            }
        
            return acc;
        }, {});

        // Finalizamos creando un array de arrays de las agrupaciones 
        if(destDocValue === 'W'){
            finalItems = Object.values(finalGrouping).flatMap(itemGroups => 
                Object.values(itemGroups).flatMap(serieGroups => 
                    Object.values(serieGroups)
                )
            );
        }else{
            finalItems = Object.values(finalGrouping).flatMap(group =>
                Array.isArray(group) ? group : Object.values(group)
            );
        }      
    
        if(finalItems.length > 0){
            return { flag: true, message: '', finalItems};
        }else{
            return { flag: false, message: 'Ocurrió un error al verificar las partidas finales, intente nuevamente' };
        }
    }

    render() {
        const { activeTab } = this.state;

        return (
            <div className='Content'>
                <div className="container p-0">
                    <div className="pt-3">
                        <div className="d-none d-lg-flex">
                            <ul className="nav nav-tabs w-100" id="myTab" role="tablist">
                                {tapTitles.map((title, index) => (
                                    <li key={index} className="nav-item">
                                        <a 
                                            key={index}
                                            className={`nav-link font-weight-bold text-secondary`}
                                            id={`nav-tab-${index}`}
                                            data-toggle="tab"
                                            href={`#tab-${index}`}
                                            role="tab"
                                            aria-controls={`tab-${index}`}
                                            aria-selected={activeTab === index}
                                            onClick={() => this.setState({ activeTab: index })}
                                        >
                                            {activeTab === index ? title : this.truncateTitle(title)}
                                        </a>
                                    </li> 
                                ))}
                            </ul>
                        </div>
                        {/* RESPONSIVE */}
                        <div className="d-flex d-lg-none">
                            <ul className="nav nav-tabs w-100" id="myTab" role="tablist">
                                <li className="nav-item ml-3 dropdown">
                                    <a className="nav-link font-weight-bold text-secondary dropdown-toggle active" data-toggle="dropdown" href="#r" role="button" aria-haspopup="true" aria-expanded="false">Menú</a>
                                    <div className="dropdown-menu p-0">
                                        {tapTitles.map((title, index) => (
                                            <a 
                                                key={index}
                                                className={`dropdown-item custom-dropdown-item font-weight-bold text-secondary`} 
                                                id={`nav-tab-${index}`}
                                                data-toggle="tab"
                                                href={`#tab-${index}`}
                                                role="tab"
                                                aria-controls={`tab-${index}`}
                                                aria-selected={activeTab === index}
                                                onClick={() => this.setState({ activeTab: index })}
                                            >
                                                {activeTab === index ? title : this.truncateTitle(title)}
                                            </a>
                                        ))}
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>                
                {this.renderBody()}
            </div>
        );
    }
}

export default ContentProvConfAssistant;